import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_5 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "btn-content" }
const _hoisted_8 = {
  key: 0,
  class: "loading-text"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_12 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["controls", { 'portrait-mode': _ctx.isPortraitMode }])
  }, [
    _createElementVNode("button", {
      class: "control-btn summary-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('summarize'))),
      disabled: !_ctx.isConnected,
      title: "总结对话"
    }, [...(_cache[8] || (_cache[8] = [
      _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        width: "24",
        height: "24",
        fill: "none"
      }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM14 2v6h6v12H6V2h8zM10 14H8v-2h2v2zm0-4H8V6h2v4zm4 4h-2v-2h2v2zm0-4h-2V6h2v4z"
        })
      ], -1)
    ]))], 8, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(["glass-button-bar", { 'tech-bar': !_ctx.isConnected, portrait: _ctx.isPortraitMode }])
    }, [
      (!_ctx.isConnected)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "tech-bar-ring" }, null, -1)),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "tech-bar-glow" }, null, -1)),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "tech-bar-scan" }, null, -1)),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "tech-bar-dots" }, [
              _createElementVNode("span"),
              _createElementVNode("span"),
              _createElementVNode("span"),
              _createElementVNode("span"),
              _createElementVNode("span"),
              _createElementVNode("span")
            ], -1))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isConnected)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "control-btn interrupt-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('interrupt'))),
            disabled: !_ctx.isConnected,
            title: "打断"
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              width: "24",
              height: "24",
              fill: "none"
            }, [
              _createElementVNode("rect", {
                x: "6",
                y: "6",
                width: "12",
                height: "12",
                rx: "2",
                fill: "currentColor"
              })
            ], -1)
          ]))], 8, _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.isConnected)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: _normalizeClass(["control-btn microphone-btn", { active: !_ctx.isMicrophoneMuted }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-microphone'))),
            disabled: !_ctx.isConnected,
            title: "麦克风"
          }, [
            (_ctx.isMicrophoneMuted)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("path", {
                    fill: "currentColor",
                    d: "M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"
                  }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("path", {
                    fill: "currentColor",
                    d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z"
                  }, null, -1)
                ]))]))
          ], 10, _hoisted_3))
        : _createCommentVNode("", true),
      (!_ctx.isConnected)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            class: _normalizeClass(["video-call-btn tech-btn", { loading: _ctx.isConnecting }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('connect'))),
            disabled: _ctx.isConnecting,
            title: "开启视频通话"
          }, [
            _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"tech-ring tech-ring-1\" data-v-45e55888></div><div class=\"tech-ring tech-ring-2\" data-v-45e55888></div><div class=\"tech-ring tech-ring-3\" data-v-45e55888></div><div class=\"tech-core\" data-v-45e55888></div><div class=\"tech-glow\" data-v-45e55888></div><div class=\"tech-scan\" data-v-45e55888></div><div class=\"tech-dots\" data-v-45e55888><span data-v-45e55888></span><span data-v-45e55888></span><span data-v-45e55888></span><span data-v-45e55888></span><span data-v-45e55888></span><span data-v-45e55888></span></div>", 7)),
            _createElementVNode("div", _hoisted_7, [
              _cache[16] || (_cache[16] = _createStaticVNode("<svg class=\"tech-icon\" viewBox=\"0 0 64 64\" width=\"28\" height=\"28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-45e55888><defs data-v-45e55888><linearGradient id=\"techGradient\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"100%\" data-v-45e55888><stop offset=\"0%\" style=\"stop-color:#00d4ff;\" data-v-45e55888></stop><stop offset=\"50%\" style=\"stop-color:#0099ff;\" data-v-45e55888></stop><stop offset=\"100%\" style=\"stop-color:#0066ff;\" data-v-45e55888></stop></linearGradient><linearGradient id=\"techGradient2\" x1=\"0%\" y1=\"100%\" x2=\"100%\" y2=\"0%\" data-v-45e55888><stop offset=\"0%\" style=\"stop-color:#66e0ff;\" data-v-45e55888></stop><stop offset=\"100%\" style=\"stop-color:#00b3ff;\" data-v-45e55888></stop></linearGradient><filter id=\"techGlow\" x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" data-v-45e55888><feGaussianBlur stdDeviation=\"2\" result=\"blur\" data-v-45e55888></feGaussianBlur><feMerge data-v-45e55888><feMergeNode in=\"blur\" data-v-45e55888></feMergeNode><feMergeNode in=\"SourceGraphic\" data-v-45e55888></feMergeNode></feMerge></filter></defs><g filter=\"url(#techGlow)\" data-v-45e55888><rect x=\"8\" y=\"18\" width=\"32\" height=\"28\" rx=\"4\" fill=\"url(#techGradient)\" class=\"camera-body\" data-v-45e55888></rect><rect x=\"10\" y=\"20\" width=\"28\" height=\"24\" rx=\"2\" fill=\"rgba(0,0,0,0.4)\" data-v-45e55888></rect><circle cx=\"24\" cy=\"32\" r=\"8\" fill=\"none\" stroke=\"url(#techGradient2)\" stroke-width=\"2\" class=\"lens-ring\" data-v-45e55888></circle><circle cx=\"24\" cy=\"32\" r=\"5\" fill=\"url(#techGradient)\" class=\"lens-core\" data-v-45e55888></circle><circle cx=\"22\" cy=\"30\" r=\"2\" fill=\"rgba(255,255,255,0.9)\" class=\"lens-highlight\" data-v-45e55888></circle><path d=\"M40 24 L50 20 L50 44 L40 40 Z\" fill=\"url(#techGradient)\" class=\"camera-side\" data-v-45e55888></path><path d=\"M40 26 L48 22 L48 42 L40 38 Z\" fill=\"rgba(0,0,0,0.3)\" data-v-45e55888></path></g></svg>", 1)),
              (_ctx.isConnecting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "connecting..."))
                : _createCommentVNode("", true)
            ])
          ], 10, _hoisted_6))
        : (_openBlock(), _createElementBlock("button", {
            key: 4,
            class: "end-call-btn",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('disconnect'))),
            title: "结束通话"
          }, [...(_cache[18] || (_cache[18] = [
            _createStaticVNode("<div class=\"btn-glow end-glow\" data-v-45e55888></div><div class=\"btn-glow-ring end-ring\" data-v-45e55888></div><svg viewBox=\"0 0 64 64\" width=\"32\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-45e55888><defs data-v-45e55888><linearGradient id=\"redGradient\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"100%\" data-v-45e55888><stop offset=\"0%\" style=\"stop-color:#ff5252;\" data-v-45e55888></stop><stop offset=\"50%\" style=\"stop-color:#ff1744;\" data-v-45e55888></stop><stop offset=\"100%\" style=\"stop-color:#d50000;\" data-v-45e55888></stop></linearGradient><filter id=\"redGlow\" x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" data-v-45e55888><feGaussianBlur stdDeviation=\"3\" result=\"blur\" data-v-45e55888></feGaussianBlur><feMerge data-v-45e55888><feMergeNode in=\"blur\" data-v-45e55888></feMergeNode><feMergeNode in=\"SourceGraphic\" data-v-45e55888></feMergeNode></feMerge></filter></defs><g filter=\"url(#redGlow)\" data-v-45e55888><path d=\"M12 24 C12 20, 16 16, 22 16 L42 16 C48 16, 52 20, 52 24 L52 40 C52 44, 48 48, 42 48 L22 48 C16 48, 12 44, 12 40 Z\" fill=\"url(#redGradient)\" data-v-45e55888></path><rect x=\"16\" y=\"22\" width=\"16\" height=\"20\" rx=\"2\" fill=\"rgba(0,0,0,0.3)\" data-v-45e55888></rect><circle cx=\"24\" cy=\"32\" r=\"5\" fill=\"rgba(255,255,255,0.2)\" data-v-45e55888></circle><path d=\"M36 26 L44 22 L44 42 L36 38 Z\" fill=\"rgba(0,0,0,0.3)\" data-v-45e55888></path><line x1=\"20\" y1=\"20\" x2=\"44\" y2=\"44\" stroke=\"#fff\" stroke-width=\"3\" stroke-linecap=\"round\" data-v-45e55888></line></g></svg>", 3)
          ]))])),
      (_ctx.isConnected)
        ? (_openBlock(), _createElementBlock("div", {
            key: 5,
            class: _normalizeClass(["volume-wrapper", { portrait: _ctx.isPortraitMode }])
          }, [
            _createElementVNode("input", {
              type: "range",
              min: "0",
              max: "100",
              value: _ctx.volume,
              onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleVolumeInput && _ctx.handleVolumeInput(...args))),
              class: "volume-slider"
            }, null, 40, _hoisted_9),
            _createElementVNode("button", {
              class: "control-btn volume-btn",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('toggle-volume-mute'))),
              disabled: !_ctx.isConnected,
              title: "音量"
            }, [
              (_ctx.isVolumeMuted || _ctx.volume === 0)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("path", {
                      fill: "currentColor",
                      d: "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73 4.27 3zM12 4l-2.28 2.28L12 8.56z"
                    }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("path", {
                      fill: "currentColor",
                      d: "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
                    }, null, -1)
                  ]))]))
            ], 8, _hoisted_10)
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["extra-buttons", { portrait: _ctx.isPortraitMode }])
    }, [
      _createElementVNode("button", {
        class: "control-btn logout-btn",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('logout'))),
        title: "退出登录"
      }, [...(_cache[21] || (_cache[21] = [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          width: "24",
          height: "24",
          fill: "none"
        }, [
          _createElementVNode("path", {
            fill: "currentColor",
            d: "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5z"
          }),
          _createElementVNode("path", {
            fill: "currentColor",
            d: "M4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
          })
        ], -1)
      ]))])
    ], 2)
  ], 2))
}